import React from "react";
import ReactDOM from "react-dom/client";

import "./assets/fonts/Evil-Empire.ttf"
import "./index.css";
import "./i18n";
import reportWebVitals from "./reportWebVitals";

import {
    BrowserRouter,
    // createBrowserRouter,
    Route,
    // RouterProvider,
    Routes,
} from "react-router-dom";
import AppWrapper from "./components/shared/AppWrapper";
import { QueryProvider } from "./providers/QueryProvider";
import IndexHome from "./pages/home/Index";
import IndexContact from "./pages/contact/Index";
// import IndexRegistration from "./pages/registration/Index.old";
import Faq from "./pages/race-information/Faq";
import CategoryPodium from "./pages/race-information/CategoryPodium";
import RulesRegulation from "./pages/race-information/RulesRegulation";
import Prize from "./pages/race-information/Prize";
import RaceDay from "./pages/race-information/RaceDay";
import RaceResult from "./pages/race-information/RaceResult";
import Gallery from "./pages/gallery/Index";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/Store";
import { PersistGate } from "redux-persist/integration/react";
import Registration from "./pages/registration/Index";
import RegistrationGroupOf3 from "./pages/registration/GroupOf3";
import RedeemVoucher from "./pages/redeem-voucher";
import Invitation from "./pages/invitation";
import Login from "./pages/login/Index";
import Profile from "./pages/profile/Index";

import ComingSoon from "./pages/coming-soon/Index";
import Countdown from "./pages/countdown/Index";
import NotFound from "./pages/not-found/Index";
import MedalWeek from "./pages/medal-week/Index";

// const router = createBrowserRouter([
//     {
//         path: "/",
//         element: <IndexHome />,
//     },
//     {
//         path: "/information/faq",
//         element: <Faq />,
//     },
//     {
//         path: "/information/race-result",
//         element: <RaceResult />,
//     },
//     {
//         path: "/information/rules-regulations",
//         element: <RulesRegulation />,
//     },
//     {
//         path: "/information/prize",
//         element: <Prize />,
//     },
//     {
//         path: "/information/category-podium",
//         element: <CategoryPodium />,
//     },
//     {
//         path: "/information/race-day",
//         element: <RaceDay />,
//     },
//     {
//         path: "/information/race-day",
//         element: <RaceDay />,
//     },
//     {
//         path: "/contact-us",
//         element: <IndexContact />,
//     },
//     {
//         path: "/registration",
//         element: <IndexRegistration />,
//     },
//     {
//         path: "/gallery",
//         element: <IndexGallelry />,
//     },
// ]);

const isOpenRegistration = process.env.REACT_APP_IS_OPEN_REGISTRATION === "true";

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <QueryProvider>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <BrowserRouter>
                        <AppWrapper>
                            {/* <RouterProvider router={router} /> */}
                            <Routes>
                                {/* DONT FORGET TO CHANGE TO INDEX HOME LATER! */}
                                <Route path="/" element={<IndexHome />} />
                                <Route path="/alternate-home" element={<IndexHome />} />
                                <Route path="/information/faq" element={<Faq />} />
                                <Route path="/information/race-result" element={<RaceResult />} />
                                <Route
                                    path="/information/rules-regulations"
                                    element={<RulesRegulation />}
                                />
                                <Route path="/information/prize" element={<Prize />} />
                                <Route
                                    path="/information/category-podium"
                                    element={<CategoryPodium />}
                                />
                                <Route path="/information/race-day" element={<RaceDay />} />
                                <Route path="/contact-us" element={<IndexContact />} />
                                {/* <Route path="/registration" element={<IndexRegistration />} /> */}
                                <Route path="/gallery" element={<Gallery />} />
                                <Route path="/registration" element={isOpenRegistration ? <Registration /> : <NotFound />} />
                                <Route path="/redeem-voucher" element={<RedeemVoucher />} />
                                <Route path="/invitation" element={<Invitation />} />
                                <Route path="/login" element={isOpenRegistration ? <Login /> : <NotFound />} />
                                <Route path="/profile" element={isOpenRegistration ? <Profile /> : <NotFound />} />
                                <Route path="/coming-soon" element={<ComingSoon />} />
                                <Route path="/countdown" element={<Countdown />} />
                                <Route path="/group-of3-2026" element={<RegistrationGroupOf3 />} />
                                <Route path="/medal-week" element={<MedalWeek />} />
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        </AppWrapper>
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        </QueryProvider>
    </React.StrictMode>
);

reportWebVitals();
